import config from 'config'

function isImage(image) {
  if (image) {
    if (typeof image === 'object') {
      return !!image.file
    }
    throw 'Image is not an object.'
  }
  return false
}

export function imagePath(image) {
  if (isImage(image)) {
    return `${config.IMG_BASE_URL}/${image.file}`
  }
}

export function imageOrDataUrl(image, files) {
  if (image) {
    if (typeof files === 'object') {
      if (typeof image === 'object') {
        return image
      }
      if (typeof image === 'string') {
        if (image in files) {
          return files[image]
        }
        throw 'Image not found in files.'
      } else {
        throw 'Image is not an object or a string.'
      }
    } else {
      throw 'Files is not an object.'
    }
  }
}

export function imageUrl(image, files) {
  if (image) {
    image = imageOrDataUrl(image, files)
    return typeof image === 'object' ? imagePath(image) : image
  }
}
